import { MaxusDealerDetail } from './MaxusDealer.model';
export default class DealerDetail {
    dealerdetailContainer;
    establishmentDetailPageUrl;
    constructor() {
        this.dealerdetailContainer = document.querySelector('.js-establishment-detail');
        if (!this.dealerdetailContainer)
            return;
        let maxusDealerDetail;
        fetch(this.dealerdetailContainer.dataset.establishmentdetail)
            .then((response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
            .then((data) => {
            maxusDealerDetail = new MaxusDealerDetail(data.result.title, data.result.address['street'], data.result.address['houseNumber'], data.result.address['postalCode'], data.result.address['city'], data.result.phoneNumber, data.result.phoneNumberLink, data.result.id, data.result.slug, data.result.services, data.result.websiteUrl, data.result.image['1000x750'], data.result.email, data.result.openingHours, data.result.whatsappNumber);
            this.initDealerDetail(maxusDealerDetail);
        })
            .catch((error) => {
            console.error('Error fetching data:', error);
        });
    }
    initDealerDetail(maxusDealerDetail) {
        this.dealerdetailContainer.append(maxusDealerDetail.renderDetailView());
    }
}
